<template>
  <section class="login-wrapper closefriend-hero w-100 hv-100 d-flex align-items-center justify-content-center">
    <global-message></global-message>
    
    <!-- Fixed Logo at Top Left -->
    <router-link class="navbar-brand m-0 p-0" :to="{name: 'HomePage'}" replace style="position: fixed; top: 16px; left: 20px; z-index: 1050; text-decoration: none;">
      <span class="stella-logo-text" style="font-size: 24px;">✨ stella✦</span>
    </router-link>

    <div class="login-container w-100 px-3" style="max-width: 480px;">
      <!-- Login Card -->
      <div class="login-card p-md-5 p-4">
        <form @submit.prevent="login()">
          <loading-modal :is-loading="isLoading"></loading-modal>
          
          <div class="text-center mb-4 pb-2">
          <h2 class="text-white font-weight-bold font-size-28 font-family-poppins m-0">{{ headerLabel }}</h2>
          <p class="text-white-50 mt-2 mb-0 font-size-15" v-if="!isSuffixCustomRequest">Sign in to your account to continue.</p>
        </div>

        <div class="text-center mb-4" v-if="isSuffixCustomRequest">
          <img v-if="!isAvatarMissing" :src="imageURL" class="profile-img rounded-circle" @error="imageLoadError">
          <img v-else src="@/assets/images/default_user.png" class="profile-img rounded-circle">
          <div class="text-white mt-2 font-weight-600">@{{ inviteeName }}</div>
        </div>

        <div class="form-group mb-4">
          <label for="email" class="text-white font-size-14 mb-2 font-weight-500">Email Address</label>
          <input id="email" type="text" autocomplete="false" placeholder="Enter your email address"
                 class="form-control stella-input"
                 name="username"
                 v-model="username">
          <div class="error invalid-feedback d-block mt-1" v-if="isRequired('username')">This is required field</div>
        </div>

        <div class="form-group mb-4">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <label for="password" class="text-white font-size-14 mb-0 font-weight-500">Password</label>
            <a href="#" class="font-size-14 gradient-text text-decoration-none font-weight-500" @click.prevent="$refs.sendOTP.show()">Forgot Password?</a>
          </div>
          <div class="input-group stella-input-group flex-nowrap">
            <input autocomplete="false" placeholder="Enter your password"
                   type="password" class="form-control stella-input border-end-0" id="password"
                   name="password" v-model="password">
            <div class="input-group-text bg-transparent stella-input-border border-start-0 cursor-pointer" @click="showPassword('password')">
              <i id="show_id" class="fa fa-eye text-white-50"></i>
              <i id="hide_id" class="fa fa-eye-slash text-white-50 d-none"></i>
            </div>
          </div>
          <div class="error invalid-feedback d-block mt-1" v-if="isRequired('password')">This is required field</div>
        </div>

        <div class="form-group mb-4">
          <div class="d-flex align-items-center cursor-pointer" @click="isRememberMe = !isRememberMe; rememberMe()">
            <input type="checkbox" name="remember" class="stella-checkbox m-0" id="remember-me" v-model="isRememberMe" @change="rememberMe" @click.stop>
            <label class="text-white-50 font-size-14 ms-2 mb-0 cursor-pointer" for="remember-me" @click.stop style="line-height: 1;">Remember Me</label>
          </div>
        </div>

        <div class="form-group mt-5 text-center">
          <button type="submit" class="btn stella-btn gradient-a w-100 font-weight-600 py-3 rounded-pill font-size-16 text-white">
            Log In
          </button>
        </div>
        </form>
      </div>
      
      <forgot-password-send-o-t-p ref="sendOTP" @otpSent="(changePassword) => {
        $refs.verifyOTP.show(changePassword)
      }"/>
      <forgot-password-verify-o-t-p ref="verifyOTP" @otpVerified="(changePassword) => {
        $refs.changePwd.show(changePassword)
      }"/>
      <forgot-password-change-pwd ref="changePwd"/>
    </div>
  </section>
</template>

<script>


import {AXIOS, AXIOS_LOGIN, getTokenExp, isRole, setRememberMe} from "@/common/http-common";
import {cleanUpAfterLogout, getLoginBody, storeToken} from '@/common/login-service';
import {ACCESS_TOKEN} from "@/properties/close-friend";
import {mapActions, mapGetters} from "vuex";
import {commMsg} from '@/properties/common-messages';
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import {required} from "vuelidate/lib/validators";
import HeaderHelp from "@/components/module/influencer/shared/HeaderHelp";
import LoadingModal from "@/components/module/shared/LoadingModal";
import {showPassword} from '@/common/Utils'
import ForgotPasswordChangePwd from "@/components/module/shared/ForgotPasswordChangePwd";
import ForgotPasswordSendOTP from "@/components/module/shared/ForgotPasswordSendOTP";
import ForgotPasswordVerifyOTP from "@/components/module/shared/ForgotPasswordVerifyOTP";
import {SERVICE_CONTENT, SERVICE_IDENTIY} from "@/properties/micro-service";
import {httpMixin} from "@/mixin/http-mixin";
import {isSuffixCustomRequest} from "@/common/comm-service";
import {
  ROUTE_CREATE_CUSTOMER_INSTAGRAM,
  ROUTE_CREATE_CUSTOMER_PLATFORM, ROUTE_CREATE_CUSTOMER_PLATFORM_EXCL_CUSTOM_REQUEST,
  ROUTE_CREATE_CUSTOMER_SNAPCHAT,
  ROUTE_CREATE_CUSTOMER_TIKTOK
} from "@/router/module/subscriber/customer-routes";
import titleMixin from "../../../mixin/title-mixin";

export default {
  name: 'LoginMobile',
  title: 'Login',
  components: {
    HeaderHelp, GlobalMessage, ForgotPasswordChangePwd,
    ForgotPasswordSendOTP, ForgotPasswordVerifyOTP, LoadingModal
  },
  mixins: [httpMixin, titleMixin],
  data() {
    return {
      username: null,
      password: null,
      inviteeName: null,
      isSubmit: false,
      isRememberMe: false,

      imageURL: null,
      isAvatarMissing: false,

    }

  },
  validations: {
    username: {required},
    password: {required},
  },
  created() {
    //Remove old token if it exists
    cleanUpAfterLogout();
    this.clearAllStore();
    if (this.$route.params.isSaved) {
      this.setMessage('Saved successfully, you can login now');
    }
    this.loadAvatarImgAndName();
  },
  mounted() {
    /*    this.$loadScript("/assets/js/bootstrap.min.js")
          .then(() => {
            console.log("loaded - bootstrap");
            this.$loadScript("/assets/js/main.js")
              .then(() => {
                console.log("loaded - main");
              })
              .catch(() => {
                console.log("error");
              });
          })
          .catch(() => {
            console.log("error");
          });*/

  },
  computed: {
    ...mapGetters(['getRedirectedFrom']),
    headerLabel() {
      return this.isSuffixCustomRequest ? 'Sign up or Login' : 'Welcome to Stella';
    },
    isSuffixCustomRequest() {
      return isSuffixCustomRequest(this.getRedirectedFrom);
    },
    isFromCreateAccount() {
      let redirectedFrom = this.$route.query.redirectedFrom;
      return (redirectedFrom === ROUTE_CREATE_CUSTOMER_SNAPCHAT
        || redirectedFrom === ROUTE_CREATE_CUSTOMER_INSTAGRAM
        || redirectedFrom === ROUTE_CREATE_CUSTOMER_TIKTOK
        || redirectedFrom === ROUTE_CREATE_CUSTOMER_PLATFORM);
    }
  },
  methods: {
    ...mapActions(['clearAllStore']),
    ...mapActions(['setMessage']),
    rememberMe() {
      setRememberMe(this.isRememberMe);
    },
    showPassword,
    isRequired(attrib) {
      return this.isSubmit && !this.$v[attrib].required;
    },
    isValidEmail() {
      return this.isSubmit && !this.$v.username.email;
    },
    signUp() {
      if (this.isSuffixCustomRequest) {
        let urlPrefix = this.$route.params.urlPrefix;
        this.$router.replace({name: 'Platform', params: {urlPrefix}})
      } else {
        cleanUpAfterLogout();
        this.$router.replace({name: 'HomePage'})
      }
    },
    login() {

      this.isSubmit = true;
      this.rememberMe();
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      console.log(`${this.username} ${this.password}`);
      const body = getLoginBody(this.username, this.password);

      console.log(body);
      this.isLoading = true
      AXIOS_LOGIN().post(`${SERVICE_IDENTIY}/oauth/token`, body)
        .then(response => {

          storeToken(response);
          this.clearAllStore();
          this.setMessage('Successfully logged in!');
          // this.refreshToken(); //This is for testing remove latter
          console.log('Expiry: ', getTokenExp(ACCESS_TOKEN));

          if (isRole('INFLUENCER')) {
            this.$router.replace({name: 'CreatorDashboardMobile'});
          } else {
            let urlPrefix = this.$route.params.urlPrefix;
            if (this.isSuffixCustomRequest) {
              this.$router.replace({name: 'CustomerCustomRequestList1', params: {urlPrefix}});
            } else if(this.$route.query.redirectedFrom === ROUTE_CREATE_CUSTOMER_PLATFORM_EXCL_CUSTOM_REQUEST ) {
              this.$router.replace({name: 'CustomerBonusContentList'});
            } else if (this.isFromCreateAccount) {
              this.$router.replace({
                name: this.$route.query.redirectedFrom,
                params: {urlPrefix},
                query: {createPlatform: true}
              });
            } else if(this.getRedirectedFrom) {
              this.$router.replace({
                path: this.getRedirectedFrom
              });
            } else {
              this.$router.replace({name: 'CustomerRouter', params: {urlPrefix}});
            }
          }
        })
        .catch(e => {
          this.catchError3(e);
        })
    },
    catchError3(error) {
      this.isLoading = false;
      if (error.response) {
        if (error.response.status === 400) {
          // this.error = commMsg['Login.Invalid'];
          this.pushGlobalError(commMsg['Login.Invalid']);
        } else {
          // this.error = error.response.data;
          this.pushGlobalError(error.response.data);
        }
        if (this.username) {
          console.log('catchError3');
          this.pushGlobalError('Invalid email or password')
        }
      } else if (error.request) {
        this.error = commMsg['Network.Error'];
      } else {
        // Something happened in setting up the request that triggered an Error
        this.error = error.message;
      }
    },
    imageLoadError(event) {
      this.isAvatarMissing = true;
    },
    loadAvatarImgAndName() {
      if (!this.isSuffixCustomRequest) {
        return;
      }
      let invitee = this.$route.params.urlPrefix;
      let url = `${SERVICE_CONTENT}/api/v1/influencers/urlSuffix/${invitee}/avatar`;
      this.getUnSecureData(url, (imageURL) => {
        this.imageURL = imageURL.replace('dp', 'dp_150X150');
        this.isAvatarMissing = false;
      });

      this.getUnSecureData(`${SERVICE_IDENTIY}/api/v1/influencers/urlSuffix/${invitee}`, (data) => {
        console.log(data);
        this.inviteeName = data.name;

      });
    },
    setBuildInfoLastOne() {
      AXIOS().get('buildInfo')
        .then(response => {
          if (response.data.buildInfo) {
            this.buildInfo = response.data.buildInfo;
          }
          this.setFocus();
        })
        .catch(e => {
          this.catchError3(e);
        })
    }
  }

}
;
</script>

<style scoped>

.login-wrapper {
  min-height: 100vh;
}

.glass-card {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
}

.stella-input,
input[type="password"].stella-input {
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: white !important;
  padding: 12px 20px;
  border-radius: 12px;
  font-size: 15px;
  transition: all 0.3s ease;
}

.stella-input:-webkit-autofill,
input[type="password"].stella-input:-webkit-autofill,
.stella-input:-webkit-autofill:hover, 
.stella-input:-webkit-autofill:active{
    -webkit-box-shadow: 0 0 0 1000px #1a1a1a inset !important;
    box-shadow: 0 0 0 1000px #1a1a1a inset !important;
    -webkit-text-fill-color: #ffffff !important;
    color: #ffffff !important;
    caret-color: #ffffff !important;
    transition: background-color 50000s ease-in-out 0s !important;
}

.stella-input:-webkit-autofill:focus,
input[type="password"].stella-input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 1000px #1a1a1a inset, 0 0 0 4px rgba(197, 111, 209, 0.2) !important;
    box-shadow: 0 0 0 1000px #1a1a1a inset, 0 0 0 4px rgba(197, 111, 209, 0.2) !important;
    border-color: #C56FD1 !important;
    -webkit-text-fill-color: #ffffff !important;
    color: #ffffff !important;
    caret-color: #ffffff !important;
    transition: background-color 50000s ease-in-out 0s !important;
}

.stella-input:focus,
input[type="password"].stella-input:focus {
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: #C56FD1 !important;
  box-shadow: 0 0 0 4px rgba(197, 111, 209, 0.1) !important;
}

.stella-input::placeholder,
input[type="password"].stella-input::placeholder {
  color: rgba(255, 255, 255, 0.3);
}

.stella-input-border {
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0 12px 12px 0;
  transition: all 0.3s ease;
}

.stella-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #C56FD1;
  margin: 0;
}

.stella-input:focus + .stella-input-border {
  border-color: #C56FD1;
}

.gradient-text {
  background: linear-gradient(135deg, #C56FD1 0%, #2F4FE9 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}

.profile-img {
  width: 70px;
  height: 70px;
  object-fit: cover;
  border: 2px solid #C56FD1;
  padding: 2px;
}

</style>
